<template>
    <div class="wrap">
        <img :src="`${publicPath}/img/tuichu.png`" style="width: 25px; float: left;color: white;position: absolute;top:10px;left: 10px;z-index: 2000" @click="logOut">

        <div class="hd">
            <div class="info">
                <img src="../../../static/img/logo.png" alt="">
                <p>{{user.name}}</p>
            </div>

        </div>
        <div class="btn_wrap">
            <van-button color="#e32322" @click="jump('registerAdmin')">管理员注册</van-button>
            <van-button color="#e32322" @click="jump('registerTuangan')">团干部注册</van-button>
            <van-button color="#e32322" @click="jump('registerTuanyuan')">共青团员注册</van-button>

        </div>
    </div>

</template>

<script>
    // import MyHeader from '../../components/MyHeader'
    import {mapState} from 'vuex'
    export default {
        name: "home",
        data(){
            return{
                publicPath: process.env.BASE_URL,
            }
        },
        computed: {
            ...mapState({
                user: state => state.user,
            }),
        },
        methods:{
            logOut() {
                console.log("logOut")
                let self = this
                let param = new FormData()

                this.loading = true
                this.$root.PF('/signout', param, {})
                    .then(function (response) {
                        console.log(response)
                        self.loading = false

                        if (response.status == 200) {
                            self.$store.commit('CLEAR')
                            self.$store.commit('CLEAR_PARAMS')
                            window && window.localStorage.clear()
                            self.jump('/')
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {

                        } else if (error.request) {
                            console.log(error.request);

                        } else {
                            // Something happened in setting up the request that triggered an Error
                            console.log('Error', error.message);
                        }
                        console.log(error.config);
                    });
            },
        }

        // components: {MyHeader},
    }
</script>

<style scoped>
    .wrap{
        background-color: #eeedf0;
        height: 100%;
        width: 100%;
        /*overflow-y: scroll;*/
    }
    .hd{
        width: 100%;
        height: 150px;
        background-color: #e32322;
        position: relative;
        /*text-align: center;*/
    }
    .hd .info{
        width: 100px;
        height: 100px;
        position: absolute;
        bottom: -55px;
        left: 50%;
        margin-left: -55px;
    }
    .hd .info img{
        width: 100px;
        height: 100px;
        border:3px solid white;
        background-color: white;
    }
    .hd .info p{
        width: 110px;
        text-align: center;
        font-size: 20px;
        color: #434343;
        margin: 5px 0;
    }

    .btn_wrap{
         width: 80%;
         height: 40px;
         margin: 150px auto;
     }
    /deep/ .van-button--normal {
        width: 100%;
        border-radius: 5px;
        margin: 20px 0;
    }


</style>
